import { render, staticRenderFns } from "./SurveyVideoUpload.vue?vue&type=template&id=516818c8&scoped=true"
import script from "./SurveyVideoUpload.vue?vue&type=script&lang=js"
export * from "./SurveyVideoUpload.vue?vue&type=script&lang=js"
import style0 from "./SurveyVideoUpload.vue?vue&type=style&index=0&id=516818c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516818c8",
  null
  
)

export default component.exports